import { Input, InputField } from "@/components/ui/input";
import { Text } from "@/components/ui/text";
import { VStack } from "@/components/ui/vstack";
import { T, useT } from "@transifex/react";

type LicensePlateInputProps = {
  onAdd: (newPlate: string) => void;
  setInputValue: (value: string) => void;
  inputValue: string;
  setInputError: (value: boolean) => void;
  inputError: boolean;
  errorMessage: string | null;
  clearError: () => void;
};

export function LicensePlateInput({ onAdd, setInputValue, inputValue, inputError, setInputError, clearError, errorMessage }: Readonly<LicensePlateInputProps>) {
  const t = useT();
  return (
    <VStack className="gap-[6px]">
      <Text className="font-[600] leading-[20px] text-[14px] text-typography-900">
        <T _str="License plate" />
      </Text>

      <Input
        className={`h-[52px] pt-[8px] pb-[8px] pl-[4px] gap-[8px] rounded-[6px] border-[1px] ${inputError ? "bg-error-50 border-error-400" : "bg-background-100 border-secondary-700"}`}
      >
        <InputField
          className="text-typography-900 text-[16px] font-[400] leading-[22px] align-middle placeholder-text-typography-900 placeholder-opacity-50"
          data-test-id="vehicleInputField"
          placeholder={t("ABC123")}
          value={inputValue}
          onChangeText={(text: string) => {
            setInputValue(
              text
                .replace(/[^a-z0-9]/gi, "")
                .toUpperCase()
                .slice(0, 12),
            );
            setInputError(false);
          }}
          onFocus={() => {
            setInputError(false);
            clearError();
          }}
          autoFocus
          autoCapitalize="characters"
          onSubmitEditing={() => onAdd(inputValue.trim().toUpperCase().slice(0, 12))}
          maxLength={12}
        />
      </Input>
      {errorMessage && <Text className="text-error-100 text-[14px] leading-[20px]">{errorMessage}</Text>}
    </VStack>
  );
}
